import React, { useEffect, useRef, useState } from 'react';
import QrScanner from 'qr-scanner';
import { I } from '@/lib/icons';

export default function QrScanModal({ open, onClose, onScan }) {
  const videoRef = useRef(null);
  const scannerRef = useRef(null);
  const [error, setError] = useState('');
  const [starting, setStarting] = useState(true);

  useEffect(() => {
    if (!open || !videoRef.current) return undefined;

    setStarting(true);
    setError('');

    const scanner = new QrScanner(
      videoRef.current,
      (result) => {
        const text = result?.data || result;
        if (!text) return;
        scanner.stop();
        onScan(text);
      },
      {
        preferredCamera: 'environment',
        highlightScanRegion: true,
        highlightCodeOutline: true,
        maxScansPerSecond: 5,
      }
    );
    scannerRef.current = scanner;

    scanner.start()
      .then(() => setStarting(false))
      .catch((e) => {
        setStarting(false);
        setError(e?.message || 'Nepodarilo sa spustiť kameru.');
      });

    return () => {
      scanner.stop();
      scanner.destroy();
      scannerRef.current = null;
    };
  }, [open, onScan]);

  if (!open) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)',
        backdropFilter: 'blur(8px)', zIndex: 1100,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        animation: 'cd-modalIn 0.2s var(--ease)',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: 'var(--bg-surface)',
          borderRadius: 'var(--r-2xl)',
          padding: 16,
          width: 'min(420px, 92vw)',
          boxShadow: 'var(--sh-modal)',
        }}
      >
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          marginBottom: 12, padding: '0 4px',
        }}>
          <div style={{ fontSize: 15, fontWeight: 600, color: 'var(--text-primary)' }}>
            Naskenuj QR z bloku
          </div>
          <button onClick={onClose} className="cd-btn cd-btn-ghost cd-btn-sm">
            <I.x /> Zavrieť
          </button>
        </div>

        <div style={{
          position: 'relative',
          width: '100%',
          aspectRatio: '1',
          borderRadius: 'var(--r-lg)',
          overflow: 'hidden',
          background: '#000',
        }}>
          <video
            ref={videoRef}
            playsInline
            muted
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
          {starting && (
            <div style={{
              position: 'absolute', inset: 0, display: 'flex',
              alignItems: 'center', justifyContent: 'center',
              color: '#fff', fontSize: 13, gap: 8,
            }}>
              <span className="cd-spinner" /> Spúšťam kameru...
            </div>
          )}
        </div>

        <p style={{
          margin: '12px 4px 0', fontSize: 12, color: 'var(--text-muted)',
          textAlign: 'center', lineHeight: 1.45,
        }}>
          {error
            ? <span style={{ color: 'var(--danger)' }}>{error}</span>
            : 'Namier kameru na QR kód na bloku z eKasa pokladne.'}
        </p>
      </div>
    </div>
  );
}
